export default function (categories) {
  return categories.map(item => {
    return {
      id: item.id,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      list: []
    }
  })
}
